import { runGetApiRequest } from 'services/Api';

import { GIST_DETAILS_ROUTE } from 'constants/apiRoutes';
import { formatRoute } from 'utils/formatters';

export const getGistDetails = (gistId: string) => (
  runGetApiRequest({
    endpoint: formatRoute(GIST_DETAILS_ROUTE, { gistId }),
    params: {},
  })
);
